import { MutationFunction } from '@apollo/client';
import { message } from 'antd';
import { CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutation, IdentityVerificationCaseV1BlobFileInput, CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutation } from '../../../../../../generated';
import { AuthResult } from '../../../../../shared/file-upload/azure-upload';


export const GetIdCaseAuthHeader = async (
  caseId: string,
  fileData: File,
  filename: string,
  getAuthHeaderForPdfFile: MutationFunction<
    CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutation,
    { input: IdentityVerificationCaseV1BlobFileInput }
  >,
  getAuthHeaderForImageFile: MutationFunction<
    CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutation,
    { input: IdentityVerificationCaseV1BlobFileInput }
  >
): Promise<AuthResult> => {
  if (fileData.type === 'application/pdf') {
    return getAuthHeaderForPdfFile({
      variables: {
        input: {
          caseId,
          fileName: filename,
          contentType: fileData.type,
          contentLength: fileData.size
        }
      }
    })
      .then((response) => {
        return {
          ...response?.data?.identityVerificationCaseV1PdfFileCreateAuthHeader,
          ...{ isAuthorized: true }
        } as AuthResult;
      })
      .catch((error) => {
        console.error('Error uploading asset: ', error);
        message.error('Error getting authorization');
        return { isAuthorized: false } as AuthResult;
      });
  }

  return getAuthHeaderForImageFile({
    variables: {
      input: {
        caseId,
        fileName: filename.replace('.pdf', '-preview.png'),
        contentType: fileData.type,
        contentLength: fileData.size
      }
    }
  })
    .then((response) => {
      return {
        ...response?.data?.identityVerificationCaseV1ImageFileCreateAuthHeader,
        ...{ isAuthorized: true }
      } as AuthResult;
    })
    .catch((error) => {
      console.error('Error uploading asset: ', error);
      message.error('Error getting authorization');
      return { isAuthorized: false } as AuthResult;
    });
};
